var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 121,
    viewBox: "0 0 147 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 121,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 44,
    height: 4,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 30,
    width: 25,
    height: 3,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 84,
    width: 72,
    height: 6,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 25,
    width: 36,
    height: 3,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 44,
    width: 48,
    height: 3,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 34,
    width: 25,
    height: 4,
    fill: "#E0E0E0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 97,
    width: 84,
    height: 6,
    fill: "#E0E0E0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 20.5,
    width: 61,
    height: 31,
    rx: 1.5,
    stroke: "#E0E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.dba7726772c70d9a83e8f24f4250fe3d.svg";
export { ForwardRef as ReactComponent };